import axios from 'axios'
import Toastify from 'toastify-js'
import "toastify-js/src/toastify.css"
import { findAll, find } from '../utils/dom';

export default function contatoForm() {
	const showToastify = (message, opts) => {
		Toastify({
			duration: 3000,
			position: "center",
			style: { background: "rgba(193, 255, 129)", fontSize: "18px", color: "rgba(45, 71, 120, 1)" },
			text: message,
			...opts
		}).showToast();
	}



	const $ = {
		form: findAll('[js-form-contato]')
	}

	function handleSubmitForm(){

		$.form?.forEach((form_item)=>{
			form_item?.addEventListener("submit", (e) =>{
				e.preventDefault();
	
				const idForm = parseInt(e.target.getAttribute('js-form-contato'));
				const form = new FormData(e.target);
				const buttonSubmit = e.target.querySelectorAll(`button[type='submit']`);


				disabledBtn(buttonSubmit);

				let form_data, url;
	
				switch(idForm){
					case 1:
						form_data = {
							nome: form.get('nome'),
							email: form.get('email'),
							assunto: form.get('assunto'),
							mensagem: form.get('mensagem')
						}

						url = "/enviar-email-administrativo/"
						axios.post(url, form_data)
							.then((response) => showMessage(response,buttonSubmit, e.target))
							.catch((response) => showMessage(response,buttonSubmit, e.target));

					break;

					case 2:
						form_data = {
							nome: form.get('nome'),
							email: form.get('email'),
							assunto: form.get('assunto'),
							mensagem: form.get('mensagem')
						}
	 					url = "/enviar-email-cultural/"
						axios.post(url, form_data)
							.then((response) => showMessage(response,buttonSubmit, e.target))
							.catch((response) => showMessage(response,buttonSubmit, e.target));
					break;

					case 3:
						form_data = {
							nome: form.get('nome'),
							email: form.get('email'),
							assunto: form.get('assunto'),
							mensagem: form.get('mensagem')
						}
	 					url = "/enviar-email-salao-cha/"
						axios.post(url, form_data)
							.then((response) => showMessage(response,buttonSubmit, e.target))
							.catch((response) => showMessage(response,buttonSubmit, e.target));
					break;

					case 4:
						form_data = {
							nome: form.get('nome'),
							email: form.get('email'),
							assunto: form.get('assunto'),
							mensagem: form.get('mensagem')
						}
	 					url = "/enviar-email-atendimento-educativo/"
						axios.post(url, form_data)
							.then((response) => showMessage(response,buttonSubmit, e.target))
							.catch((response) => showMessage(response,buttonSubmit, e.target));
					break;

					case 5:
						form_data = {
							nome: form.get('nome'),
							email: form.get('email'),
							assunto: form.get('assunto'),
							mensagem: form.get('mensagem')
						}
	 					url = "/enviar-email-atendimento-pesquisadores/"
						axios.post(url, form_data)
							.then((response) => showMessage(response,buttonSubmit, e.target))
							.catch((response) => showMessage(response,buttonSubmit, e.target));
					break;

					case 6:
						form_data = {
							nome: form.get('nome'),
							email: form.get('email'),
							assunto: form.get('assunto'),
							mensagem: form.get('mensagem')
						}
	 					url = "/enviar-email-acessoria-imprensa/"
						axios.post(url, form_data)
							.then((response) => showMessage(response,buttonSubmit, e.target))
							.catch((response) => showMessage(response,buttonSubmit, e.target));
					break;

					case 7:
						form_data = {
							nome: form.get('nome'),
							email: form.get('email'),
							assunto: form.get('assunto'),
							mensagem: form.get('mensagem')
						}
	 					url = "/enviar-email-agendamento-eventos/"
						axios.post(url, form_data)
							.then((response) => showMessage(response,buttonSubmit, e.target))
							.catch((response) => showMessage(response,buttonSubmit, e.target));
					break;
				}
				
	
			})
		})
	}

	handleSubmitForm();







	//const btnFormContato = document.querySelectorAll('.btn-contact')

/*
	const formContato = document.querySelector('#enter-in-contact')


	formContato?.addEventListener("submit", (e) => {
		e.preventDefault();
		disabledBtn()

		const form = new FormData(e.target);

		const form_data = {
			nome: form.get('nome'),
			email: form.get('email'),
			assunto: form.get('assunto'),
			mensagem: form.get('mensagem')
		}

		const url = "/fale-conosco/"
		axios.post(url, form_data)
			.then((response) => showMessage(response))
			.catch((response) => showMessage(response));
	})


	const formNewsLetter = document.querySelector('[js-form-newsletter]');



	formNewsLetter?.addEventListener("submit", (e) => {
		e.preventDefault();
		disabledBtn();

		const form = new FormData(e.target);

		const form_data = {
			email: form.get('receba-news'),
		}

		const url = "/newsletter/"
		axios.post(url, form_data)
			.then((response) => showMessage(response))
			.catch((response) => showMessage(response));

	})*/


	/*
		if (btnFormContato) {
		
			btnFormContato.forEach((btn) => {
		
				formContato && btn.addEventListener('click', function (event) {
					event.preventDefault();
					disabledBtn()
		
					const form = new FormData(event);
					console.log(form)
		
					const form_data = {
						nome: `${primeiro_nome.value}`,
						email: email.value,
						mensagem: box_text.value,
						area_interesse: area_interesse.value,
						telefone: telefone.value,
						//assunto: assunto.value,
					}
		
					const url = "/fale-conosco/"
					axios.post(url, form_data)
						.then((response) => showMessage(response))
						.catch((response) => showMessage(response));
	});
		})
	} */

	const Languagem = document.querySelector('[lang]').lang;

	function showMessage(response, btnFormContato, form) {
		const isSuccess = response.data && response.data.message;
		const message = response.data ? response.data.message : response.message

		//message = isSuccess ? 'Mensagem enviada com sucesso! Obrigado!' : 'Oops, aconteceu algo de errado! Tente de novo!'


		const backgroundColor = isSuccess ? "rgba(193, 255, 129)" : "rgba(233, 44, 44)";
		const textColor = isSuccess ? "rgba(45, 71, 120, 1)" : "white";

		showToastify(message, {
			style: {
				background: backgroundColor,
				color: textColor,
				fontSize: "18px",
				borderRadius: "8px"
			},
		});
		form?.reset()
		setTimeout(enabledBtn(btnFormContato), 1000)
	}

	function disabledBtn(btnFormContato) {
		btnFormContato.forEach((btn) => {
			btn.disabled = true
			btn.classList.add("disabled")
		})
	}

	function enabledBtn(btnFormContato) {
		btnFormContato.forEach((btn) => {
			btn.disabled = false
			btn.classList.remove("disabled")
		})
	}
}